export function Mission() {
  return (
    <section id="mission" className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-8">
          {/* Main Heading */}
          <h2 className="text-3xl sm:text-4xl font-semibold text-gray-900 font-sans">
            Excellence in music for six decades.
          </h2>
          
          {/* Mission Statement */}
          <div className="space-y-6">
            <p className="text-lg text-gray-700 font-sans leading-relaxed">
              Our success is due to the very heart and core of our mission:
            </p>
            
            <p className="text-lg text-gray-700 font-sans leading-relaxed max-w-3xl mx-auto">
              It is our goal to provide a venue for a dynamic and collaborative environment, 
              where the finest musicians share their passion for their art with the community. 
              Also, to provide students with every opportunity to excel through the compassionate 
              instruction, inspiration, and motivation of each dedicated teaching artist.
            </p>
          </div>
          
          {/* Teaching Philosophy */}
          <div className="space-y-6 pt-8">
            <p className="text-lg text-gray-700 font-sans leading-relaxed max-w-3xl mx-auto">
              The studio musicians at the{' '}
              <strong className="text-gray-900 font-semibold">
                Conservatory of Musical Arts Group
              </strong>{' '}
              meet each and every student where they are in terms of their musical experience. 
              Whether you are skilled and looking to fine-tune certain aspects of your practice 
              or are brand new to the music world, our teachers have something to offer. Through 
              their experience and expertise, they guide, nurture, and help each individual student thrive.
            </p>
            
            <p className="text-lg text-gray-700 font-sans leading-relaxed max-w-3xl mx-auto">
              CMA Group's music lessons are fun, dynamic, and tailored to each and every age. 
              Come as you are and allow CMA Group's artist-teachers and community to become 
              a part of your musical development.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}